import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { AccountSummaryPerAppItemEntity } from '../../entities/org-metrics/account-summary-per-app-item.entity';

export interface AccountSummaryItemAggregateRootProps {
  thisPeriod: AccountSummaryPerAppItemEntity;
  previousPeriod: AccountSummaryPerAppItemEntity;
}

export class AccountSummaryItemAggregateRoot extends Entity<AccountSummaryItemAggregateRootProps> {
  protected _id: string;
  protected _hourlyRate: number;
  static create(
    props: AccountSummaryItemAggregateRootProps,
    entityId?: string
  ): AccountSummaryItemAggregateRoot {
    const id = entityId || v4();
    const entity = new AccountSummaryItemAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}

  set hourlyRate(hourlyRate: number) {
    this._hourlyRate = hourlyRate;
  }

  get count(): number {
    return this.props.thisPeriod.count;
  }

  get value(): number {
    return this.props.thisPeriod.value;
  }

  get average(): number {
    return this.props.thisPeriod.average;
  }

  get cost(): number {
    return this._hourlyRate * this.value;
  }

  get key(): string {
    return this.props.thisPeriod.key;
  }

  get deviation(): number {
    return this.props.thisPeriod.value - this.props.previousPeriod.value;
  }

  get averageDeviation(): number {
    return this.props.thisPeriod.average - this.props.previousPeriod.average;
  }

  get averageCost(): number {
    return this.props.thisPeriod.average * this._hourlyRate;
  }

  get averageCostDeviation(): number {
    return (
      this.props.thisPeriod.average * this._hourlyRate -
      this.props.previousPeriod.average * this._hourlyRate
    );
  }

  get costDeviation(): number {
    return (
      this.props.thisPeriod.value * this._hourlyRate -
      this.props.previousPeriod.value * this._hourlyRate
    );
  }

  get previousPeriodValue(): number {
    return this.props.previousPeriod.value;
  }

  get previousPeriodCount(): number {
    return this.props.previousPeriod.count;
  }
}
